import { captureException } from '@sentry/react'

export interface Logger {
  captureException: typeof captureException
}

const sentryLogger: Logger = {
  captureException,
}

export default sentryLogger
